import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=4dfe8eb0&scoped=true"
import script from "./DeliveryList.vue?vue&type=script&lang=js"
export * from "./DeliveryList.vue?vue&type=script&lang=js"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=4dfe8eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe8eb0",
  null
  
)

export default component.exports